@switch (bannerStyle) {
  @case ('Full') {
    <div
      [rmaStaticAssetBg]="'/assets/images/promotion-banner/black-friday-2024/black-friday-bg.png'"
      class="flex w-full flex-col items-center justify-center gap-6 rounded-md bg-cover bg-center p-5 md:flex-row md:justify-around md:p-7"
    >
      <img
        [src]="'/assets/images/promotion-banner/black-friday-2024/lg-black-friday-sale.png' | staticAsset"
        class="h-24 hidden md:block"
        alt="Black Friday Sale"
      />
      <img
        [src]="'/assets/images/promotion-banner/black-friday-2024/lg-percentage-off.png' | staticAsset"
        class="h-24 -mt-4"
        alt="25% Off"
      />
      <a routerLink="/billing/subscription-features" mat-flat-button class="!bg-purple-50 !text-white !min-w-[150px]"> Claim My Offer </a>
    </div>
  }
  @case ('NoCta') {
    <div
      [rmaStaticAssetBg]="'/assets/images/promotion-banner/black-friday-2024/black-friday-bg.png'"
      class="w-full rounded-md bg-cover bg-center bg-no-repeat p-3 text-center text-white flex flex-col md:flex-row gap-4 md:gap-8 justify-between items-center px-12"
    >
      <img
        [src]="'/assets/images/promotion-banner/black-friday-2024/lg-black-friday-sale.png' | staticAsset"
        class="h-18 hidden md:block"
        alt="Black Friday Sale"
      />
      <img
        [src]="'/assets/images/promotion-banner/black-friday-2024/lg-percentage-off.png' | staticAsset"
        class="h-16 md:h-24 -mt-4"
        alt="25% Off"
      />
      <a routerLink="/billing/subscription-features" mat-flat-button class="!bg-purple-50 !text-white !min-w-[150px]"> Claim My Offer </a>
    </div>
  }
  @case ('Small') {
    <div
      [rmaStaticAssetBg]="'/assets/images/promotion-banner/black-friday-2024/black-friday-bg.png'"
      class="w-full rounded-md bg-cover bg-center bg-no-repeat p-3 text-center text-white"
    >
      You're one step away from claiming your <span class="font-bold">3 months free</span>
    </div>
  }
}
